import { createFileRoute } from "@tanstack/react-router";
import HowFastCanDepressionTreatmentStartWorking from "@/pages/articles/HowFastCanDepressionTreatmentStartWorking";
export const Route = createFileRoute(
  "/how-fast-can-depression-treatment-start-working",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "How Fast Can Depression Treatment Start Working | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How quickly does depression treatment work? Compare TMS, SAINT TMS, SPRAVATO, and ketamine onset times. Learn about fast relief in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "How Fast Can Depression Treatment Start Working | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How quickly does depression treatment work? Compare TMS, SAINT TMS, SPRAVATO, and ketamine onset times. Learn about fast relief in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/how-fast-can-depression-treatment-start-working",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-fast-can-depression-treatment-start-working",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HowFastCanDepressionTreatmentStartWorking />;
}
